import { TimesheetSecurity } from "../../Api/timesheetSecurity";
import {
  GET_TIMESHEETSECURITY_FAILURE,
  GET_TIMESHEETSECURITY_SUCCESS,
  GET_TIMESHEETSECURITY_REQUEST
} from "../../Constants";

function getTimesheetSecurityRequest() {
  return {
    type: GET_TIMESHEETSECURITY_REQUEST,
    isFetching: true
  };
}
function getTimesheetSecuritySuccess(data) {
  return {
    type: GET_TIMESHEETSECURITY_SUCCESS,
    isFetching: false,
    securityList: data
  };
}
function getTimesheetSecurityfailure(data) {
  return {
    type: GET_TIMESHEETSECURITY_FAILURE,
    isFetching: false,
    data
  };
}

//Get Technician Working hours
export const getTimesheetSecurity = payload => (dispatch, getState) => {
  dispatch(getTimesheetSecurityRequest());
  TimesheetSecurity.getTimesheetSecurityData(payload)
    .then(res => {
      dispatch(getTimesheetSecuritySuccess(res));
    })
    .catch(err => dispatch(getTimesheetSecurityfailure(err)));
};
